import script from "./CarouselAd.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselAd.vue?vue&type=script&setup=true&lang=js"

import "./CarouselAd.vue?vue&type=style&index=0&id=15e7f827&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15e7f827"]])

export default __exports__